import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

// Employee Sidebar Links
const EmployeeNavbarLinks = [
  { resource: "dashboard", path: "/employee-dashboard", title: "Dashboard", icon: "📊" },
  { resource: "profile", path: "/employee-profile", title: "Profile", icon: "👤" },
  { resource: "apply-leave", path: "/employee/apply-leave", title: "Apply Leave", icon: "📅" },
  { resource: "leave-history", path: "/employee/leave-history", title: "Leave History", icon: "📋" },
];

const EmployeeDashboardSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [loginType, setLoginType] = useState("employee");

  // Retrieve loginType from localStorage
  useEffect(() => {
    const storedLoginType = localStorage.getItem("loginType");
    if (storedLoginType) {
      setLoginType(storedLoginType);
    }
  }, []);

  // Handle mouse hover to expand/collapse sidebar
  const handleMouseEnter = () => {
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  // Only show sidebar for employee login type
  if (loginType !== "employee") {
    return null;
  }

  return (
    <div
      className={`dashboard-sidebar ${isOpen ? "expanded" : "collapsed"}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        position: "fixed",
        left: 0,
        top: "60px", // Account for header height
        height: "calc(100vh - 60px)",
        width: isOpen ? "250px" : "60px",
        backgroundColor: "#2c3e50",
        color: "white",
        transition: "width 0.3s ease",
        zIndex: 1000,
        overflowX: "hidden",
        boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
      }}
    >
      <div style={{ padding: "20px 0" }}>
        <div
          style={{
            textAlign: "center",
            padding: "0 15px 20px",
            borderBottom: "1px solid #34495e",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              fontSize: isOpen ? "18px" : "24px",
              fontWeight: "bold",
              color: "#ecf0f1",
              transition: "all 0.3s ease",
            }}
          >
            {isOpen ? "Employee Portal" : "📋"}
          </div>
        </div>

        <nav>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {EmployeeNavbarLinks.map((link, index) => (
              <li key={index} style={{ margin: "5px 0" }}>
                <NavLink
                  to={link.path}
                  style={({ isActive }) => ({
                    display: "flex",
                    alignItems: "center",
                    padding: "15px 20px",
                    color: isActive ? "#3498db" : "#ecf0f1",
                    textDecoration: "none",
                    backgroundColor: isActive ? "#34495e" : "transparent",
                    borderLeft: isActive ? "4px solid #3498db" : "4px solid transparent",
                    transition: "all 0.3s ease",
                    fontSize: "14px",
                  })}
                  onMouseEnter={(e) => {
                    if (!e.target.closest('.active')) {
                      e.target.style.backgroundColor = "#34495e";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!e.target.closest('.active')) {
                      e.target.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  <span
                    style={{
                      fontSize: "18px",
                      marginRight: isOpen ? "15px" : "0",
                      transition: "margin 0.3s ease",
                      width: "20px",
                      textAlign: "center",
                    }}
                  >
                    {link.icon}
                  </span>
                  <span
                    style={{
                      opacity: isOpen ? 1 : 0,
                      transition: "opacity 0.3s ease",
                      whiteSpace: "nowrap",
                      fontWeight: "500",
                    }}
                  >
                    {link.title}
                  </span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {/* User info at bottom */}
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          left: "0",
          right: "0",
          padding: "0 15px",
          borderTop: "1px solid #34495e",
          paddingTop: "15px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "12px",
            color: "#bdc3c7",
          }}
        >
          <span
            style={{
              fontSize: "16px",
              marginRight: isOpen ? "10px" : "0",
              transition: "margin 0.3s ease",
            }}
          >
            👨‍💼
          </span>
          <span
            style={{
              opacity: isOpen ? 1 : 0,
              transition: "opacity 0.3s ease",
              whiteSpace: "nowrap",
            }}
          >
            Employee Dashboard
          </span>
        </div>
      </div>
    </div>
  );
};

export default EmployeeDashboardSidebar;
